(function() {
    function initColl(root) {
        var wrap = root.querySelector('[data-vp-thread]');
        if (!wrap || wrap.dataset.vpInit) return;
        wrap.dataset.vpInit = '1';

        /* ---- scroll reveal for the intro block ---- */
        var section = wrap.closest('[data-vp-collections]');
        var revealTargets = section ? section.querySelectorAll('.vp-reveal') : [];
        var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        if ('IntersectionObserver' in window && !reduce) {
            var revealIO = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) { entry.target.classList.add('in');
                        revealIO.unobserve(entry.target); }
                });
            }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
            revealTargets.forEach(function(el) { revealIO.observe(el); });
            setTimeout(function() { revealTargets.forEach(function(el) { el.classList.add('in'); }); }, 3800);
        } else {
            revealTargets.forEach(function(el) { el.classList.add('in'); });
        }

        /* ---- The Thread: scroll-drawn path ---- */
        var path = wrap.querySelector('.vp-tj-path');
        var bg = wrap.querySelector('.vp-tj-path-bg');
        var sts = [].slice.call(wrap.querySelectorAll('.vp-tj-st'));
        if (!path || !bg || !sts.length) return;

        /* Prefer the designated final stop's medallion; fall back to the very
           last stop's medallion so the thread still works even if no stop is
           marked final (e.g. only 1-2 blocks configured so far). */
        var endMed = wrap.querySelector('.vp-tj-final .vp-tj-med') || sts[sts.length - 1].querySelector('.vp-tj-med');
        if (!endMed) return;

        var segments = sts.length;
        var rafId = null;

        function layoutPath() {
            var wr = wrap.getBoundingClientRect();
            var mr = endMed.getBoundingClientRect();
            var yEnd = Math.max(((mr.top + mr.height / 2 - wr.top) / Math.max(wr.height, 1)) * 1000, 200);
            var s = yEnd / segments;
            var d = 'M50 0';
            for (var i = 1; i <= segments; i++) {
                var prev = (i - 1) * s,
                    cur = i * s;
                d += ' C58 ' + (prev + s * 0.38).toFixed(1) + ' 42 ' + (prev + s * 0.62).toFixed(1) + ' 50 ' + cur.toFixed(1);
            }
            path.setAttribute('d', d);
            bg.setAttribute('d', d);
        }

        function tick() {
            rafId = null;
            var vh = innerHeight;
            sts.forEach(function(st) {
                var b = st.getBoundingClientRect();
                st.classList.toggle('lit', b.top + b.height * 0.4 < vh * 0.8);
            });
        }

        function requestTick() {
            if (rafId === null) rafId = requestAnimationFrame(tick);
        }

        layoutPath();
        tick();

        if (reduce) {
            /* skip the animated tracking; light every stop */
            sts.forEach(function(st) { st.classList.add('lit'); });
            return;
        }

        addEventListener('scroll', requestTick, { passive: true });
        addEventListener('resize', function() { layoutPath();
            requestTick(); });
        addEventListener('load', function() { layoutPath();
            requestTick(); });

        /* images loading (async) shift stop positions -> recompute the path
           geometry each time one finishes, so the curve stays accurate */
        var imgs = [].slice.call(wrap.querySelectorAll('img'));
        imgs.forEach(function(img) {
            if (img.complete) return;
            img.addEventListener('load', function() { layoutPath();
                requestTick(); }, { once: true });
        });

        /* catch late layout shifts (fonts swapping in, etc.) */
        if ('ResizeObserver' in window) {
            var ro = new ResizeObserver(function() { layoutPath();
                requestTick(); });
            ro.observe(wrap);
        }
        [300, 900, 1800].forEach(function(ms) {
            setTimeout(function() { layoutPath();
                requestTick(); }, ms);
        });
    }

    function boot() { initColl(document); }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function(e) { initColl(e.target); });
})();